<template lang="pug">
div
    IntroScreen(v-if="serviceType==0")
    IntroScreenOne(v-if="serviceType==1")
    IntroScreenTwo(v-if="serviceType==2")
    IntroScreenThree(v-if="serviceType==3")
</template>

<script>
import IntroScreen from '../views/IntroScreen.vue';
import IntroScreenThree from '../views/IntroScreenThree.vue';
import IntroScreenOne from '../views/IntroScreenOne.vue';
import IntroScreenTwo from '../views/IntroScreenTwo.vue';
export default {
    computed: {
        serviceType() {
            return this.$dealer.default_settings.serviceType;
        }
    },
    components: {
        IntroScreen,
        IntroScreenOne,
        IntroScreenTwo,
        IntroScreenThree
    }
}
</script>